module.exports = __webpack_public_path__ + "fonts/fontello.8de78978.ttf";